const config = {
  baseApi: process.env.REACT_APP_BASE_URL,
  baseImage: process.env.REACT_APP_IMAGE_URL,
};

export default config;